import { render } from "./TournamentScheduleList.vue?vue&type=template&id=94be6ee6&scoped=true"
import script from "./TournamentScheduleList.vue?vue&type=script&lang=js"
export * from "./TournamentScheduleList.vue?vue&type=script&lang=js"

import "./TournamentScheduleList.vue?vue&type=style&index=0&id=94be6ee6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94be6ee6"]])

export default __exports__